import template from './leave_restriction_rule_leave_type_edit.html';
import tr from '../../lib/default-translator.js';

class LeaveRestrictionRuleLeaveTypeEditViewModel
{
	constructor (dialog)
	{
		this.dialog = dialog;
		this.rule_name = ko.observable();
		this.description = ko.observable();
		this.parsed_description = ko.observable();
		this.customization_rules = ko.observableArray();
		this.holiday_types = ko.observableArray();

		this.intervalOptions = ko.observableArray([
			{ 'name': 'Hour(s)', 'db_value': 'hour' },
			{ 'name': 'Day(s)', 'db_value': 'day' },
			{ 'name': 'Month(s)', 'db_value': 'month' },
			{ 'name': 'Year(s)', 'db_value': 'year' }
		]);
	};

	close()
	{
		this.dialog.close();
	}

	async update_and_save()
	{
		let data = {
			customization_rules: this.customization_rules()
		};

		let customizationReturnData = new Object();
		let newDescriptionReturnData;
		let raw_desc = this.dialog.bindings.data.inherited_rule_description;

		if (raw_desc == undefined)
			newDescriptionReturnData = this.dialog.bindings.data.rule_description;
		else
			newDescriptionReturnData = this.dialog.bindings.data.inherited_rule_description;

		// validate here - make sure the custom fields are numbers
		for (let a = 0; a < data.customization_rules.length; a++)
		{
			if (data.customization_rules[a].type == 'integer')
			{
				let tempValue = Number(data.customization_rules[a].value);
				if (isNaN(tempValue) || tempValue < 0)
				{
					Grape.alerts.alert({type: 'error', message: tr('Please make sure you use only positive numbers.', 'Please make sure you use only positive numbers.'), title: 'Validation Failure'});
					return;
				}
			} else if (data.customization_rules[a].type == 'interval')
			{
				// its ok we dont need to validate since its a dropdown
			}

			// build object to return
			customizationReturnData[data.customization_rules[a].field] =
			{
				name: data.customization_rules[a].name,
				type: data.customization_rules[a].type,
				value: data.customization_rules[a].value
			};

			let replaceStr = '{' + data.customization_rules[a].field + '}';
			let regExp = new RegExp(replaceStr, 'g');
			newDescriptionReturnData = newDescriptionReturnData.replace(regExp, data.customization_rules[a].value);
		}

		let obj_parsed = parseLeaveRestrictionRule(newDescriptionReturnData, customizationReturnData);

		let obj = {
			customization_rules: customizationReturnData,
			leave_type_linked_restrictions_id: this.dialog.bindings.data.leave_type_linked_restrictions_id,
			rule_description: obj_parsed.non_color_block_description
		};

		this.dialog.updateData();
		this.dialog.close(obj);
		newDescriptionReturnData = null;
	};
};

class LeaveRestrictionRuleLeaveTypeEditPage
{
	constructor (bindings)
	{
		this.viewModel = new LeaveRestrictionRuleLeaveTypeEditViewModel(this);
		this.bindings = bindings;
	};

	async updateData()
	{
		this.viewModel.rule_name(this.bindings.data.rule_name);

		let raw_desc = this.bindings.data.inherited_rule_description;

		if (raw_desc == undefined)
			this.viewModel.parsed_description(this.bindings.data.rule_description);
		else
			this.viewModel.parsed_description(this.bindings.data.inherited_rule_description);

		let description = new String(this.viewModel.parsed_description());
		let myfields = this.bindings.data.customization_fields_inherited;
		let obj = parseLeaveRestrictionRule(description, myfields);

		this.viewModel.customization_rules(obj.customization_rules);
		this.viewModel.description(obj.description);
	};

	async init()
	{
		let res = await Grape.fetches.getJSON('/api/record', { table: 'holiday_types', limit: 100 });
		if (res.status != 'ERROR')
			this.viewModel.holiday_types(res.records);
	};
};

export default {
	name: 'LeaveRestrictionRuleLeaveTypeEdit',
	dialog_class: LeaveRestrictionRuleLeaveTypeEditPage,
	template: template,
	template_filename: 'translation/dialogs/leave_restriction_rule_leave_type_edit',
	provider: 'ps'
};
